import PatchOps from '@leverege/api-patch-ops'

import SystemActions from './SystemActions';

/*
  Usage:
    let updater = SystemUpdater( dispatch, system )
      .set( "a/string/to/a/path", "value 1" )
      .set( "a/string/to/another/path", "value 2" )
      .done();
 */

function SystemUpdater( dispatch, system, key, value ) {
  
  const patchOps = PatchOps( key, value );

  patchOps.done = function( ) {
    dispatch( SystemActions.update( system, patchOps.ops() ) );

  }  

  return patchOps;
}

module.exports = SystemUpdater;
